import { render } from "./ClienteConsulta.vue?vue&type=template&id=16a43fd9&scoped=true"
import script from "./ClienteConsulta.vue?vue&type=script&lang=js"
export * from "./ClienteConsulta.vue?vue&type=script&lang=js"

import "./ClienteConsulta.vue?vue&type=style&index=0&id=16a43fd9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16a43fd9"]])

export default __exports__